/**
 * @generated SignedSource<<51368f1bb3a3c02a294a0e9466ce5f21>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type WidgetTeamScheduleRoutineListItemContent_RoutineOccasion$data = {
  readonly assigned: ReadonlyArray<{
    readonly employee: {
      readonly id: string;
      readonly isLinkedToViewer: boolean;
      readonly name: string;
      readonly " $fragmentSpreads": FragmentRefs<"Avatar_employee" | "ListItemAssignees_employees" | "ToolbarButtonAssignees_employees">;
    } | null;
    readonly id: string;
  }>;
  readonly assignedRoles: ReadonlyArray<{
    readonly role: {
      readonly employeeIds: ReadonlyArray<string>;
      readonly id: string;
      readonly isLinkedToViewer: boolean;
      readonly name: string;
      readonly " $fragmentSpreads": FragmentRefs<"ListItemAssignees_roles" | "ToolbarButtonAssignees_roles">;
    };
  }>;
  readonly deadlineAt: string | null;
  readonly startAt: string;
  readonly " $fragmentType": "WidgetTeamScheduleRoutineListItemContent_RoutineOccasion";
};
export type WidgetTeamScheduleRoutineListItemContent_RoutineOccasion$key = {
  readonly " $data"?: WidgetTeamScheduleRoutineListItemContent_RoutineOccasion$data;
  readonly " $fragmentSpreads": FragmentRefs<"WidgetTeamScheduleRoutineListItemContent_RoutineOccasion">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isLinkedToViewer",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "WidgetTeamScheduleRoutineListItemContent_RoutineOccasion",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "startAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "deadlineAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "AssignedEmployee",
      "kind": "LinkedField",
      "name": "assigned",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "Employee",
          "kind": "LinkedField",
          "name": "employee",
          "plural": false,
          "selections": [
            (v0/*: any*/),
            (v1/*: any*/),
            (v2/*: any*/),
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "Avatar_employee"
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "ToolbarButtonAssignees_employees"
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "ListItemAssignees_employees"
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "AssignedRole",
      "kind": "LinkedField",
      "name": "assignedRoles",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "EmployeeRole",
          "kind": "LinkedField",
          "name": "role",
          "plural": false,
          "selections": [
            (v0/*: any*/),
            (v1/*: any*/),
            (v2/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "employeeIds",
              "storageKey": null
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "ToolbarButtonAssignees_roles"
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "ListItemAssignees_roles"
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "RoutineOccasion",
  "abstractKey": null
};
})();

(node as any).hash = "1709069c3c407d28f4355ad292c1a6dd";

export default node;
